export const isBlank = (str?: string) => !str || /^\s*$/.test(str)
